/**
 * @file   src\Pages\MySubscriptions.tsx
 * @brief  MySubscriptions page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link, useState, useNavigate, useParams, useEffect,Modal } from "../utils/thirdpartyComponents"
import { Badge, Button } from "react-bootstrap";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import mysubscriptionicon from "../assets/images/my-subscriptions-img.svg"
import CWFooter from "src/components/CWFooter";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import axios from "src/config/axiosConfig";
import { ProfileApi } from "src/utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";
import { IUserSubscription } from "src/interfaces/subscriptionInterface";
import FullLoader from "src/components/FullLoader";
import CancelMySubscription from "src/components/CancelMySubscription";
import {getBayTypes, splitTotal, subscriptionRedirection, formatMinutesToMinutesSeconds} from "../utils/helper";
import moment from "moment";
import { IBayType } from "src/interfaces/bayinterface";
import { ServiceType } from "src/utils/enums";

const MySubscriptions = () => {
    const navigate = useNavigate();
    const params = useParams();
     // Instantiate MessageToaster
     const toaster = new MessageToaster();
    // State to handle user's subscription
    const [mySubscriptionsData, setMySubscriptionsData] = useState<IUserSubscription[]>();
    // State to manage more and less button
    const [showAll, setShowAll] = useState(false);
    const [loading,setLoading] =  useState(false);
    const [showcancelConfirmation, setShowcancelConfirmation] = useState(false);
    const [cancelSubscriptionID,setCancelSubscriptionID] = useState(0)


    // initial loading
    useEffect(() => {
        // fetch my subscription listing
        fetchMySubscriptions(); 
      }, []);

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    
      const fetchRedirectURL = async () => {
        const redirectURL = await subscriptionRedirection(params.carwashname ?? "");
        navigate(redirectURL ?? "");
      };
    

    const onBuynowClick = () => {
        fetchRedirectURL()
        // navigate("/" + params.carwashname + "/" + pageURLs.selectBayType)
        // navigate("/" + params.carwashname + "/" + pageURLs.subscriptionandwashprice);
    };
    const changeSubscription = (subscriptionType:number) => {
        if(subscriptionType === 0)
        {
            navigate("/" + params.carwashname + "/" + pageURLs.subscriptionandwashprice);
        }
        else{
            navigate("/" + params.carwashname + "/" + pageURLs.selfServeSubscriptionandwashprice+`?bayTypeId=${subscriptionType}`);
        }
    }
    //cancel confirmation modal close function
    const handleOnHide = () => {setShowcancelConfirmation(false)}
    //my subscription api integration
    const fetchMySubscriptions = async () => {
        try {
          setLoading(true); // Show loader
            const timezoneOffset = (new Date()).getTimezoneOffset();

          const responseProfile = await axios.get(ProfileApi.MY_SUBSCRIPTIONS,{params:{offset:timezoneOffset}});
            
          if (responseProfile?.data?.error === 0) {
            const mySubscriptions = responseProfile.data.data;
            setMySubscriptionsData(mySubscriptions);
          } else {
            toaster.toastError(responseProfile?.data?.message);
          }
        } catch (error: any) {
          throw new Error(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
          }
    };

    const cancelSubscription =  (userSubscriptionID:number) => {
        setShowcancelConfirmation(true)
        setCancelSubscriptionID(userSubscriptionID)

    }

    function showPrice(Price : number){
        const { dollars, cents } = Price? splitTotal(Price) : {dollars:"",cents:""}
        const centswith2Digit = (cents && cents.length < 2) ? cents+'0' : cents;
        return <><div className="cw-card-value">${dollars}
            <span className="decimal-sec">.{cents ? centswith2Digit : "00"}</span>
        </div></>
    }

    return (

        <div className="common-content-wrap pb-80">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/" + params.carwashname + "/" + pageURLs.settings} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> My Subscriptions
                        </div>
                    </div>
                </div>
                {loading ? <FullLoader/> : mySubscriptionsData?.length ?  (
                    <div className="main-content-wrap pe-0 ps-0 pt-0">
                        {mySubscriptionsData.map((mySubscriptions, index) => {
                            let type = mySubscriptions?.subscriptionType == 3 ? "bulk" : ""
                            return (
                            
                            <div  className="my-subscription-wrap">
                            <div className="cw-card">
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{mySubscriptions?.washName}</h6>
                                        {showAll ? <span                     dangerouslySetInnerHTML={{ __html: mySubscriptions?.subscriptionDetails }}
></span> : (mySubscriptions?.subscriptionDetails.length > 150 ? <span                     dangerouslySetInnerHTML={{ __html:`${mySubscriptions?.subscriptionDetails?.substring(0, 150)}...`}} ></span>: <span                     dangerouslySetInnerHTML={{ __html: mySubscriptions?.subscriptionDetails }}
></span>)}

                                        <div>
                                            {mySubscriptions?.subscriptionDetails?.length > 150 && (

                                                <a onClick={toggleShowAll} className="more-less-btn">
                                                    {showAll ? <>
                                                        <span className="align-text-top">Less</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </> : <><span className="align-text-top">More</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </>} </a>

                                            )}
                                        </div>
                                    </div>
                                    <div className="cw-card-rightcontent">
                                        {showPrice(mySubscriptions?.price)}
                                       
                                        {type !="bulk" ?  <div className="cw-card-smalltext">Per Month</div> :""}
                                    </div>
                                </div>
                            <div className={`cw-card-validity d-grid ${type === "bulk" ? "vacuum-validity" : ""}`}>
                                    <div className="info-block text-center">
                                        <p>{mySubscriptions?.baySubscriptionType == 0  ?"Actual Washes":"Actual Minutes"}</p>
                                        <span>{mySubscriptions?.baySubscriptionType == 0 ? mySubscriptions?.isUnlimitedWash ? 'Unlimited' :mySubscriptions?.noOfWash  : mySubscriptions?.washTime}</span>
                                    </div>
                                    <div className="info-block text-center">
                                        <p> {mySubscriptions?.baySubscriptionType == 0  ?"Remaining Washes":"Remaining Minutes"}</p>
                                        <span>{mySubscriptions?.baySubscriptionType == 0 ? mySubscriptions?.isUnlimitedWash ? 'Unlimited' : mySubscriptions?.noOfWashRemaining : formatMinutesToMinutesSeconds(mySubscriptions?.washTimeRemaining) || '0 minutes' }</span>
                                    </div>
                                   {type !="bulk" ?<div className="info-block text-center">
                                        {(moment(mySubscriptions?.startDate).isBefore(moment()))  ?
                                        <div>
                                        <p>Valid Till</p>
                                        <span>{moment(new Date(mySubscriptions?.endDate)).format("MM/DD/YYYY")}</span>
                                        </div>
                                        : <div>
                                        <p>Valid From</p>
                                        <span>{moment(new Date(mySubscriptions?.startDate)).format("MM/DD/YYYY")}</span>
                                        </div>
                                            }
                                        
                                        {mySubscriptions?.isCancelled ? <Badge bg="danger">Canceled</Badge> : ""}
                                    </div> :""}
                                   
                                </div>

                                {/* free vacuum wash */}

                                 {mySubscriptions.hasVacuumWash == 1 ? <div className="cw-card-validity vacuum-validity d-grid">
                                    <div className="info-block text-center">
                                        <p>Actual Free Vacuum Sessions </p>
                                        <span>{ mySubscriptions?.noOfVacuumWash}</span>
                                    </div>
                                    <div className="info-block text-center">
                                        <p>Remaining Free Vacuum Sessions </p>
                                        <span>{ mySubscriptions?.noOfVacuumWashRemaining}</span>
                                    </div>
                                  
                                   
                                </div> :""}
                                 {mySubscriptions.hasSelfService == 1 ? <div className="cw-card-validity vacuum-validity d-grid">
                                    <div className="info-block text-center">
                                        <p>Actual Free Self serve Sessions </p>
                                        <span>{ mySubscriptions?.numberOfSelfServices}</span>
                                    </div>
                                    <div className="info-block text-center">
                                        <p>Remaining Free Self serve Sessions </p>
                                        <span>{ mySubscriptions?.numberOfSelfServicesRemaining}</span>
                                    </div>
                                  
                                   
                                </div> :""}
                                {type !="bulk" ? !mySubscriptions?.isCancelled ?
                                <>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={()=>changeSubscription(mySubscriptions?.baySubscriptionType??0)}>Change Subscription</Button>
                                </div>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={() => cancelSubscription(mySubscriptions?.userSubscriptionID)}>Cancel Subscription</Button>
                                </div>
                                </> : "" :""
                                }
                                <div className="subscription-details" id="subscription-details">
                                {mySubscriptions.availableLocations && mySubscriptions.availableLocations.split(',').length > 0 ? (
                                <>
                                    <h4>You can use this {mySubscriptions.subscriptionType==3 ? "Prepaid Discount Package":"subscription"} in the below mentioned Locations:</h4>
                                    <ul>
                                    {mySubscriptions.availableLocations.split(',').map((locationName, idx) => (
                                        <li key={idx}>
                                        <p className="title">{locationName.trim()}</p>
                                        </li>
                                    ))}
                                    </ul>
                                </>
                                ) : (
                                <h4>You can use this subscription in all Locations</h4>
                                )}
                            </div>
                            </div>
                            
                        </div>
                  )
                }
                  )} 
                        
                    </div>
                ) : (
                    <>
                    <div className="main-content-wrap pe-0 ps-0 pt-0">
                        <div className="subscription-status-wrap text-center">
                            <div className="status-img"><img src={mysubscriptionicon} alt="Car Wash App" /></div>
                            <p>You don't have any active subscriptions</p>
                        </div>
                    </div>
                    <div className="btm-secondarybtn-wrap btm-fixed-wrap">
                    <div className="btm-inner-wrap">
                        <Button variant="primary" className="primary-btn btn-main" onClick={onBuynowClick}>Buy Now</Button>
                    </div>
                </div>
                </>
                    
                )}
            </div>
            <CWFooter activeLink="Settings"/>
        {/* cancel subscription confirmation modal */}
        <CancelMySubscription
        setShowcancelConfirmation={(flag:boolean)=>setShowcancelConfirmation(flag)}
         setLoading={(flag:boolean)=>setLoading(flag)}
        showcancelConfirmation={showcancelConfirmation}
        fetchMySubscriptions = {fetchMySubscriptions}
        from = {'mysubscription'}
        cancelSubscriptionID = {cancelSubscriptionID}
        // from={pageURLs.my_subscriptions}
        />

        </div>
    )
}

export default MySubscriptions;
